<template>
    <div class="page">
        <div class="container-fluid">
            <h1 class="irismedium">{{ $t("common.appname") }}</h1>
            <h2>
                <span class="mdi mdi-electron-framework"></span>
                {{ $t("pages.about.name") }}.
            </h2>
            <h3>
                JLL<sup>&copy;</sup> - <span class="irismedium">L.D.D.</span> Legal &
                Digital Products Department Collaboration {{ year }}
            </h3>
            <br />
            <!--<table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th>{{ $t("pages.about.table.colname") }}</th>
                        <th>{{ $t("pages.about.table.coltitle") }}</th>
                    </tr>
                </thead>

                <tbody class="table-striped">
                    <tr v-for="dev in developers" :key="dev.key">
                        <td>{{ dev.name }}</td>
                        <td>{{ dev.title }}</td>
                    </tr>
                </tbody>
            </table>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "About",
        data() {
            return {
                year: new Date().year,
                developers: [
                    {
                        key: "0",
                        name: "Teresa Martín",
                        title: "Head of Legal & Compliance",
                    },
                    {
                        key: "1",
                        name: "Beatriz Lopez",
                        title: " "
                    },
                    {
                        key: "2",
                        name: "Elena Rivas",
                        title: " "
                    },
                    {
                        key: "3",
                        name: "Elena Alcalá",
                        title: "The Black Widow"
                    },
                    {
                        key: "4",
                        name: "Álvaro Botía",
                        title: "(╯°□°)╯︵ ┻━┻"
                    },
                ],
            };
        },
    };
</script>

<style scoped>
    .page {
        padding-top: 20px;
    }
</style>
